import React, { useState } from "react";
import "./Contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const mailtoLink = `mailto:saleswellnessems@gmail.com?subject=${encodeURIComponent(
      formData.subject || "Modular OT Enquiry"
    )}&body=${encodeURIComponent(
      `Name: ${formData.name}
Email: ${formData.email}
Message: ${formData.message}`
    )}`;

    window.location.href = mailtoLink;

    setFormData({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <section className="contact-page">

      {/* HERO */}
      <div className="contact-hero">
        <h1>Modular Operation Theatre Contact & Enquiry</h1>
        <p>
          Get expert consultation for Modular OT design, installation, and NABH
          compliant solutions across India.
        </p>
      </div>

      <div className="contact-container">

        {/* LEFT SIDE */}
        <div className="contact-info">

          <div className="info-card">
            <h3>📍 Our Location</h3>
            <p>Chinchwad, Pune, Maharashtra, India</p>
          </div>

          <div className="info-card">
            <h3>📧 Email</h3>
            <p>
              <a href="mailto:saleswellnessems@gmail.com">
                saleswellnessems@gmail.com
              </a>
            </p>
          </div>

          <div className="info-card">
            <h3>📞 Call Us</h3>
            <p>
              <a href="tel:+919665457825">+91-9665457825</a> /{" "}
              <a href="tel:+919579353053">+91-9579353053</a>
            </p>
          </div>

          {/* MAP */}
          <div className="map-container">
            <a
              href="https://www.google.com/maps?q=18.673648,73.79731"
              target="_blank"
              rel="noopener noreferrer"
            >
              <iframe
                title="Modular OT Pune Location"
                src="https://www.google.com/maps?q=18.673648,73.79731&z=14&output=embed"
                loading="lazy"
              ></iframe>
            </a>
          </div>

        </div>

        {/* RIGHT SIDE FORM */}
        <div className="contact-form">

          <h2>Get Free Modular OT Quote</h2>

          <form onSubmit={handleSubmit}>

            <div className="input-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <label>Your Name</label>
            </div>

            <div className="input-group">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <label>Your Email</label>
            </div>

            <div className="input-group">
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
              <label>Hospital / Project Name</label>
            </div>

            <div className="input-group">
              <textarea
                name="message"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
              <label>Your Requirement</label>
            </div>

            <button type="submit" className="submit-btn">
              🚀 Request Quote
            </button>

          </form>
        </div>

      </div>

      {/* ✅ WHATSAPP FLOAT BUTTON (WITH PREFILLED MESSAGE) */}
      <a
        href="https://wa.me/919665457825?text=Hello%20WEMS%2C%20I%20am%20interested%20in%20Modular%20Operation%20Theatre%20(OT)%20solutions.%20Please%20share%20details%20and%20quotation."
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="../assets/icons8-whatsapp.png" alt="WhatsApp" />
      </a>

    </section>
  );
}

export default Contact;